import { styled } from "sharedUI/styles";

export const MobileOverviewScreenStyle = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    & .moss-section-title {
        margin: 20px 20px 10px 20px;
        color: ${p => p.theme.fgColorLight};
    }

    & .moss-scroll-region {
        flex: 1;
        overflow-y: auto;
    }

    & .moss-mobile-container {
        padding: 10px 10px 10px 10px;
    }

    & .moss-mobile-warning {
        color: ${p => p.theme.fgColorMedium};
        margin: 20px 0;
        text-align: center;
    }

    & .moss-footer {
        flex-shrink: 0;
        padding: 24px;

        & > * {
            width: 300px;
        }
    }

    & .moss-app {
        width: 25%;

        @media only screen and (max-width: 300px) {
            width: 33%;
        }

        height: 120px;
        display: inline-flex;
        text-align: center;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: all 250ms ease-in-out;

        color: inherit;
        text-decoration: none;
    }

    & .moss-app-title {
        color: ${p => p.theme.fgColorDark};
        margin: 8px 0 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(100% - 10px);
    }
`;
